import _ from 'lodash';

//* Use _.differenceBy instead
/**
 * Subtracts already-selected device issues from the full issue list so only remaining choices are offered. Returns the full list untouched when the selection is empty, otherwise keeps each item whose value is not found in the selected array.
 *
 * @param bigArray - Full list of device issue options.
 * @param smallArray - Already-selected issues to exclude.
 * @returns The device issue options not present in the selection.
 */
const filterArrayDeviceIssue = (bigArray: any = [], smallArray: any = []): any => {
  if (smallArray.length === 0) {
    return bigArray;
  }
  const tempArr: any = [];
  _.forEach(bigArray, (x) => {
    /**
     * Holds the small-array element whose value matches the current big-array item. Derived via lodash find comparing the value property of each candidate.
     *
     * @returns The matching element or undefined.
     */
    const item = _.find(smallArray, (y) => y.value === x.value);
    if (_.isEmpty(item)) {
      tempArr.push(x);
    }
  });
  return tempArr;
};

export { filterArrayDeviceIssue };
